import {
    Component,
    inject,
    signal,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterModule,
} from '@angular/router'
import { NgIcon } from '@ng-icons/core'
import { filter } from 'rxjs'
import { HeaderProfileMenuComponent } from '../header-profile-menu/header-profile-menu.component'

@Component({
    selector: 'app-header-admin-default',
    imports: [RouterModule, NgIcon, HeaderProfileMenuComponent],
    templateUrl: './header-admin-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-admin-default.component.css',
})
export class HeaderAdminDefaultComponent {
    userEmail = input<string>('')
    userName = input<string>('')
    userRole = input<string>('')
    pageTitle = signal<string>('')

    sidebarToggle = output<void>()

    private router = inject(Router)
    private activatedRoute = inject(ActivatedRoute)

    constructor() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntilDestroyed(),
            )
            .subscribe(() => this.updatePageTitle())
        this.updatePageTitle()
    }

    private updatePageTitle() {
        let route = this.activatedRoute.snapshot
        while (route.firstChild) {
            route = route.firstChild
        }
        this.pageTitle.set(route.data['pageTitle'] ?? '')
    }

    toggleSidebar() {
        this.sidebarToggle.emit()
    }
}
